module.exports = __webpack_public_path__ + "static/blog-post-placeholder-430692fa2380cd4b2f0a601a416839a8.png";